module.exports = __webpack_public_path__ + "img/icon17.7abb6a2e.gif";